
import { backendUrl } from "../globalConfig";
import { get, del, put, post } from "../commons/client/http";
import { GameScore, GameSplit, Game } from "../api/Team.types";
import { Page } from "api/Pagination.types";

export const getGameSplitsByPollId = async (pollId: string): Promise<Page<GameSplit>> => {
    const response = (await get(
        `${backendUrl()}/game-split?pollId=${pollId}`
    )) as Page<GameSplit>

    return response;
}

export const getGameSplitById = async (gameSplitId: string): Promise<GameSplit> => {
    const response = (await get(
        `${backendUrl()}/game-split/${gameSplitId}`
    )) as GameSplit

    return response;
}

export const getGameSplits = async (page: number, pageSize: number): Promise<Page<GameSplit>> => {
    const response = (await get(
        `${backendUrl()}/game-split?page=${page}&pageSize=${pageSize}`
    )) as Page<GameSplit>

    return response;
}

export const deleteGameSplitPlayerEntry = async (gameSplitId: string, playerId: number): Promise<boolean> => {

    const response = (await del(
        `${backendUrl()}/game-split/${gameSplitId}/team_entry/${playerId}`
    )) as boolean

    return response;
}

export const deleteGameSplitById = async (gameSplitId: string): Promise<boolean> => {

    const response = (await del(
        `${backendUrl()}/game-split/${gameSplitId}`
    )) as boolean

    return response;
}

export const moveGameSplitPlayer = async (gameSplitId: string, playerId: number, fromTeam: string, toTeam: string): Promise<GameSplit> => {
    const response = (await put(
        `${backendUrl()}/game-split/${gameSplitId}/move-player`,
        { playerId, fromTeam, toTeam }
    )) as GameSplit;

    return response;
}

export const resendGameSplitTelegram = async (gameSplitId: string): Promise<GameSplit> => {

    const response = (await post(
        `${backendUrl()}/game-split/${gameSplitId}/telegram`, {}
    )) as GameSplit;

    return response;
}

export const setGameSplitScores = async (gameSplitId: string, gameScores: GameScore[]): Promise<Game []> => {

    const response = (await post(
        `${backendUrl()}/game-split/${gameSplitId}/score`, gameScores
    )) as Game[];

    return response;
}

